import { AfterViewInit, Component, EventEmitter, Input, Output } from "@angular/core";
import { AuthService } from "src/app/services/auth.service";
import { UserService } from "src/app/services/user.service";
import * as _ from "lodash";

@Component({
  selector: "app-alternate-payment",
  templateUrl: "./alternate-payment.component.html",
  styleUrls: ["./alternate-payment.component.scss"],
})
export class AlternatePaymentComponent implements AfterViewInit {
  @Input() patientPayable: string;
  @Input() selections: any;
  @Input() selectedServices: any;
  @Input() discountDetails: any;
  @Input() parsedChargeInfo: any;
  @Input() parentApplyingCode: boolean;
  @Input() isDiscountApplied = false;
  @Input() computedDetail: any;
  @Input() apptDetail: any;
  @Input() chargeDetails: any;
  @Input() isDiscountOnApptBooking = false;
  @Input() isEnablePoints = false;
  @Input() isEnablePromo = false;
  @Input() isEnableCoupon = false;
  @Input() couponAdditionalParams: any;
  @Input() order: any;

  @Output() applyingAltPayment = new EventEmitter<any>();
  @Output() appliedAltPayment = new EventEmitter<any>();
  @Output() promochecked = new EventEmitter<any>();

  public isAutoApplyingCoupon = false;
  public isAutoApplyingPromo = false;
  public couponAutoApplyChecked = false;
  public promoAutoApplyChecked = false;

  public showCouponModal = false;
  public showPointsModal = false;
  public couponProps: any;
  public pointsProps: any;
  public showConsentModal: boolean = false;
  public consentDetails; any;
  public isConsent: boolean = false;
  public hiddenPointsUI: boolean = false;
  public userInfo: any;

  public readonly modalTypes = {
    A: {
      types: ["POINTS"],
      title: "ALTPAY#MODAL#TITLE#POINTS",
      applyButton: "ALTPAY#MODAL#BUTTON#APPLY",
    },
    B: {
      types: ["PROMO", "COUPON"],
      title: "ALTPAY#MODAL#TITLE#PROMOCOUPON",
      applyButton: "ALTPAY#MODAL#BUTTON#APPLY",
    },
    HIDDEN: {
      types: [],
      title: "",
      applyButton: "",
    },
  };

  constructor( private user: UserService, private auth: AuthService,) {
    this.getUserProfile()
    this.user.getConfigurationInfo.subscribe(data => {
      console.log('profile 123', data)
      this.consentDetails = data.profile.manageconcent;
    })
  }

  ngOnInit(): void {
    console.log('patientPayable', this.patientPayable, 'selections', this.selections, 'selectedServices', this.selectedServices, 'discountDetails', this.discountDetails, 'parsedChargeInfo', this.parsedChargeInfo, 'isDiscountApplied', this.isDiscountApplied, 'computedDetail', this.computedDetail )
    console.log('apptDetail', this.apptDetail, 'chargeDetails', this.chargeDetails, 'isDiscountOnApptBooking', this.isDiscountOnApptBooking, 'isEnablePoints', this.isEnablePoints, 'isEnablePromo', this.isEnablePromo, 'isEnableCoupon', this.isEnableCoupon, 'couponAdditionalParams', this.couponAdditionalParams, 'order', this.order)
  }

  ngAfterViewInit(): void {
    if ((this.isEnablePromo || this.isEnableCoupon) && this.computedDetail) {
      this.promochecked.emit(true);
    }
  }

  public checkAutoApplyCoupons() {
    console.log('checkAutoApplyCoupons 234')
    if (!this.couponAdditionalParams?.isPackage || this.couponAutoApplyChecked)
      return;
    this.couponAutoApplyChecked = true;
    this.isAutoApplyingCoupon = true;
    this.openAltPayments("B", { autoApply: true });
  }

  public checkAutoApplyPromo(promoCode: string) {
    if (!promoCode || this.promoAutoApplyChecked) return;
    this.promoAutoApplyChecked = true;
    this.isAutoApplyingPromo = true;
  }

  public clearPoints(ev: MouseEvent) {
    ev.stopPropagation();
    this.openAltPayments("HIDDEN", { remove: ["POINTS"] });
  }

  public async openAltPayments(key: "A" | "B" | "HIDDEN",additionalInfo: any = null,) {
    console.log("openAltPayments", key, additionalInfo);

    this.applyingAltPayment.emit({status: true, autoApply: additionalInfo?.autoApply || false});

    const attr = this.modalTypes[key];

    if (attr.types.includes("POINTS")) {
      console.log('isConsent', this.isConsent, 'consentDetails', this.consentDetails);
      if(!this.isConsent && (this.consentDetails && this.consentDetails.enableConcent ==  "Y"))
        this.showConsentModal = true;
    }

    const displayTypes = attr.types.filter((type) => {
      switch (type) {
        case "COUPON":
          return this.isEnableCoupon;
        case "PROMO":
          return this.isEnablePromo;
        case "POINTS":
          return this.isEnablePoints;
        default:
          return false;
      }
    });

    const commonProps = {
      types: displayTypes,
      actualTypes: attr.types,
      title: attr.title,
      applyButton: attr.applyButton,
      patientPayable: this.patientPayable,
      appliedPoints: this.apptDetail?.selectedDiscountDetails?.appliedPoints,
      chargeStr: this.discountDetails?.charge || "",
      parsedChargeInfo: this.parsedChargeInfo,
      discountDetails: this.discountDetails,
      computedDetail: _.cloneDeep(this.computedDetail),
      selections: this.computedDetail?.promoCodeParams,
      apptDetail: _.cloneDeep(this.apptDetail),
      chargeDetails: _.cloneDeep(this.chargeDetails),
      additionalInfo: additionalInfo,
      selectedServices: this.selectedServices,
      isDiscountOnApptBooking: this.isDiscountOnApptBooking,
      settings: {
        isEnableCoupon: this.isEnableCoupon,
        isEnablePromo: this.isEnablePromo,
        isEnablePoints: this.isEnablePoints,
      },
      couponAdditionalParams: this.couponAdditionalParams,
    };
    console.log('commonProps', commonProps);
    if (key === "A") {
      // Points Modal
      this.pointsProps = commonProps;
      this.showPointsModal = true;
    }

    if (key === "B") {
      if (additionalInfo?.autoApply && additionalInfo?.promoCode) {
        this.isAutoApplyingPromo = true;
      }
      // Promo + Coupon
      this.couponProps = commonProps;
      this.showCouponModal = true;
    }

    if (key === "HIDDEN") {
      this.pointsProps = commonProps;
      this.showPointsModal = true;
      this.hiddenPointsUI = true
      // this.removeHidden(additionalInfo);
    }
  }

  private openCouponModal(additionalInfo?: any) {
    this.isAutoApplyingCoupon = additionalInfo?.autoApply || false;

    this.couponProps = {
      types: ["PROMO", "COUPON"],
      patientPayable: this.patientPayable,
      computedDetail: _.cloneDeep(this.computedDetail),
      chargeDetails: _.cloneDeep(this.chargeDetails),
      apptDetail: _.cloneDeep(this.apptDetail),
      settings: {
        isEnableCoupon: this.isEnableCoupon,
        isEnablePromo: this.isEnablePromo,
      },
      additionalInfo,
    };

    this.showCouponModal = true;
  }

  private openPointsModal(additionalInfo?: any) {
    this.pointsProps = {
      types: ["POINTS"],
      patientPayable: this.patientPayable,
      computedDetail: _.cloneDeep(this.computedDetail),
      chargeDetails: _.cloneDeep(this.chargeDetails),
      apptDetail: _.cloneDeep(this.apptDetail),
      additionalInfo,
    };

    this.showPointsModal = true;
  }

  private removeHidden(additionalInfo: any) {
    if (additionalInfo?.remove?.includes("POINTS")) {
      this.computedDetail.isPointsApplied = false;
      this.appliedAltPayment.emit({
        computedDetail: this.computedDetail,
        apptDetail: this.apptDetail,
        chargeDetails: this.chargeDetails,
      });
    }
  }

  public completeCoupon(event: any) {
    this.showCouponModal = false;
    this.isAutoApplyingCoupon = false;
    this.isAutoApplyingPromo = false;

    if (event?.computedDetail) {
      this.emitApplied(event);
    } else {
      this.emitApplied({
        computedDetail: this.computedDetail,
        apptDetail: this.apptDetail,
        chargeDetails: this.chargeDetails,
      });
    }
  }

  public completePoints(event: any) {
    this.showPointsModal = false;
    this.hiddenPointsUI = false;
    if (event?.computedDetail) {
      this.emitApplied(event);
    } else {
      this.emitApplied({
        computedDetail: this.computedDetail,
        apptDetail: this.apptDetail,
        chargeDetails: this.chargeDetails,
      });
    }
  }

  private emitApplied(data: any) {
    this.appliedAltPayment.emit({
      computedDetail: data.computedDetail,
      apptDetail: data.apptDetail,
      chargeDetails: data.chargeDetails,
    });
  }

  public getUserProfile(val?) {
    if(!this.user.isLoggedIn()) return
    this.user.getUserProfile().subscribe(data => {
      // console.log('getUserProfile', data)
       this.userInfo = data
       this.isConsent = data.marketingConsent;
       this.user.setSSOObjectOnUpdate(data);
       if(val)
        this.user.setMarketingConsent(data.marketingConsent)
    })
  }

  public updateProfile() {
      let payload = {
        "personId": this.user.getPersonId(),
        "username": this.userInfo.username ? this.userInfo.username : this.userInfo.userName,
        "firstName":  this.userInfo.firstname ? this.userInfo.firstname : this.userInfo.firstName,
        "lastName": this.userInfo.lastname ? this.userInfo.lastname : this.userInfo.lastName,
        "gender": this.userInfo.gender,
        "locale": this.userInfo.language,
        "dob": this.userInfo.birth_date,
        "mandatoryConsent": this.userInfo.mandatoryConsent,
        "marketingConsent": this.isConsent,
       
      }
      this.auth.updateUserProfile(payload, 'CONSENT').subscribe(_ => {
        this.user.updateUserInfo({ personName: payload['firstName'] + " "+ payload['lastName']})
          this.showConsentModal = false;
          this.getUserProfile(true)
      })
    }

  completeConsent(event) {
    console.log('event', event.type)
    if(event.type == "CLOSE") {
      this.showConsentModal = false;
    } else if(event.type == "CONSENT") {
      this.showConsentModal = false;
      this.isConsent = true;
      this.openAltPayments('A');
      this.updateProfile()
    }
  }

  private updateUserProfile(): Promise<boolean> {
    return new Promise((resolve) => {
      const payload = { marketingConsent: true };

      // this.auth
      //   .updateUserProfile(payload, "", false, true, "CONSENT")
      //   .subscribe(
      //     () => resolve(true),
      //     () => resolve(false),
      //   );
    });
  }

  // public async openCoupons() {
  //   if (this.isModalOpen) return
  //   this.isModalOpen = true;
  //   this.applyingCoupon.emit({ status: true })
  //   this.couponProps = {
  //     promoDetails: this.promoCodeDetails,
  //     type: this.type == 'VIEWONLY' ? 'VIEWONLY' : 'COUPONNEW',
  //     patientPayable: this.netPayable,
  //     serviceAmount: this.totalAmount,
  //     appliedCoupons: this.appliedCoupons,
  //   }
  //   this.showCouponModal = true;
  // }
}
